import {useState} from 'react';
import {Icon, tapasClassNames} from '@ezcater/tapas';
import {faChevronDown} from '@fortawesome/pro-regular-svg-icons';
import useTranslation from 'next-translate/useTranslation';
import {twMerge} from 'tailwind-merge';

import {SearchBar} from '@/components/global/layout/AppBar/SearchBar';
import {useStoreNextRouter} from '@/components/global/providers/StoreNextRouter';
import AboutUsMenu from './AboutUsMenu';
import CompanyMenu from './CompanyMenu';
import MenuPopover from './MenuPopover';
import RestaurantMenu from './RestaurantMenu';

type LoggedOutMenuProps = {
  isOnCuisineMetroPage?: boolean;
  isOnMetroPage?: boolean;
};

const LoggedOutMenu: React.FC<LoggedOutMenuProps> = ({isOnCuisineMetroPage, isOnMetroPage}) => {
  const {t} = useTranslation('app-bar');
  const [isSearchBarOpen, setIsSearchBarOpen] = useState(false);
  const {isOnLoggedOutLandingPage} = useStoreNextRouter();

  const triggerClassName = twMerge(
    'flex shrink-0 cursor-pointer items-center gap-2 rounded font-bold',
    tapasClassNames.focusVisibleOffset,
    // On the landing page's green app bar, Tapas's black ring is about 1.7:1, leaving only its
    // 1px white offset visible.
    isOnLoggedOutLandingPage && 'focus-visible:ring-white',
  );

  return (
    <div className="flex items-center gap-10">
      <MenuPopover
        content={<CompanyMenu />}
        ariaLabel={t('navLinks.workplaceSolutions')}
        arrowClasses="right-[49px]"
        placement="bottom"
      >
        <button className={triggerClassName} type="button">
          {t('navLinks.workplaceSolutions')} <Icon icon={faChevronDown} />
        </button>
      </MenuPopover>

      <MenuPopover
        content={<RestaurantMenu />}
        ariaLabel={t('navLinks.forRestaurants')}
        arrowClasses="right-[60px]"
        placement="bottom"
      >
        <button className={triggerClassName} type="button">
          {t('navLinks.forRestaurants')} <Icon icon={faChevronDown} />
        </button>
      </MenuPopover>

      <MenuPopover
        content={<AboutUsMenu />}
        ariaLabel={t('navLinks.aboutUs')}
        arrowClasses="right-[59px]"
        placement="bottom"
      >
        <button className={triggerClassName} type="button">
          {t('navLinks.aboutUs')} <Icon icon={faChevronDown} />
        </button>
      </MenuPopover>

      {(isOnCuisineMetroPage || isOnMetroPage) && (
        <div className="hidden appbar-xl:block appbar-2xl:w-80">
          <SearchBar isOpen={isSearchBarOpen} setIsOpen={setIsSearchBarOpen} />
        </div>
      )}
    </div>
  );
};

export default LoggedOutMenu;
